import { Component } from '@angular/core';
import { NzButtonType } from 'ng-zorro-antd/button';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-view-confirm',
  templateUrl: './view-confirm.component.html',
  styleUrl: './view-confirm.component.scss',
})
export class ViewConfirmComponent {
  title = 'Confirmation';
  content = 'Are you sure you want to proceed?';
  okText = 'OK';
  cancelText = 'Cancel';
  width: number | string = 520;
  okType: NzButtonType = 'primary';

  constructor(private modalRef: NzModalRef) {}

  onConfirm(): void {
    this.modalRef.close(true);
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}

// todo: example of usage:

// constructor(private modalService: NzModalService) {}

//   showConfirmationModal(): void {
//     const modalRef = this.modalService.create({
//       nzContent: ConfirmationModalComponent,
//       nzComponentParams: {
//         title: 'Delete Confirmation',
//         content: 'Are you sure you want to delete this item?',
//         okText: 'Yes, Delete',
//         cancelText: 'No, Keep',
//         iconType: 'warning',
//         width: 600,
//       },
//       nzFooter: null,
//     });

//     modalRef.afterClose.subscribe((result: boolean) => {
//       if (result) {
//         this.handleDelete();
//       } else {
//         this.handleCancel();
//       }
//     });
//   }
